import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { useScroll } from '../context/ScrollContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pizza-premium-2/artifacts/he2ik45u_logo1.png";

const Navbar = ({ onNavigate }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { language } = useLanguage();
  const { isDark, toggleTheme } = useTheme();
  const { navbarOffset, isAtTop } = useScroll();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuClick = () => {
    const menuContainer = document.getElementById('menu-container');
    if (menuContainer) {
      const offset = 100;
      const elementPosition = menuContainer.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const useWhiteText = isAtTop || isDark;

  return (
    <nav
      data-testid="navbar"
      className={`fixed left-0 right-0 z-50 transition-colors duration-300 ${
        !isAtTop 
          ? isDark 
            ? 'bg-[#0A0A0A] border-b border-white/10 shadow-2xl' 
            : 'bg-white border-b border-black/10 shadow-lg'
          : 'bg-transparent'
      }`}
      style={{ 
        top: 0,
        transform: `translateY(${navbarOffset}px)`,
        transition: 'transform 0.2s cubic-bezier(0.2, 0.9, 0.4, 1.1)'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a 
            href="#hero"
            data-testid="logo"
            className="flex items-center gap-2 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <img 
              src={LOGO_URL} 
              alt="Don Vito" 
              className={`h-10 sm:h-12 w-auto object-contain transition-all duration-300 ${
                !useWhiteText ? 'brightness-0' : ''
              }`}
            />
          </a>

          <div className="flex items-center gap-3">
            <button
              data-testid="menu-btn"
              onClick={handleMenuClick}
              className={`px-5 py-2 rounded-full text-sm font-semibold backdrop-blur-md border transition-all duration-300 ${
                useWhiteText 
                  ? 'bg-white/10 border-white/20 text-white hover:bg-white/20' 
                  : 'bg-black/5 border-black/10 text-gray-800 hover:bg-black/10'
              }`}
            >
              {language === 'bg' ? 'Меню' : 'Menu'}
            </button>

            <button
              data-testid="theme-toggle"
              onClick={toggleTheme}
              className={`p-2 rounded-full backdrop-blur-md border transition-colors ${
                useWhiteText 
                  ? 'bg-white/10 border-white/20 text-white hover:bg-white/20' 
                  : 'bg-black/5 border-black/10 text-gray-800 hover:bg-black/10'
              }`}
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;